export default [
  {
    title: '',
    dataIndex: 'index',
    width: 55
  },
  {
    title: '文件名',
    dataIndex: 'fileName',
    scopedSlots: { customRender: 'fileName' }
  },
  {
    title: '大小',
    dataIndex: 'fileSize',
    scopedSlots: { customRender: 'fileSize' },
    width: 90
  },
  {
    title: '格式',
    dataIndex: 'fileSuffix',
    width: 60
  },
  {
    title: '操作',
    dataIndex: 'operate',
    scopedSlots: { customRender: 'operate' },
    width: 90,
    fixed: 'right'
  }
]